export const biometricIdentification = ({
  description, list_id, owner_department_id,
}) => ({
  description,
  owner_department_id,
  policies: {
    detect_policy: {
      detect_face: 1,
      multiface_policy: 1,
      estimate_head_pose: 1,
      estimate_quality: 1,
      estimate_mask: 1,
      yaw_threshold: 30,
      roll_threshold: 30,
      pitch_threshold: 30,
      estimate_liveness:
        {
          estimate: 1,
          liveness_threshold: 0.5,
        },
    },
    extract_policy: {
      extract_basic_attributes: 1,
      extract_face_descriptor: 1,
      fd_score_threshold: 0.6,
    },
    match_policy: [
      {
        label: 'list',
        candidates: {
          origin: 'faces',
          list_id,
        },
        limit: 3,
        threshold: 0.5,
      },
    ],
    storage_policy: {
      event_policy: {
        store_event: 1,
      },
    },
  },
});

export const defineAttributes = ({ description, owner_department_id }) => ({
  description,
  owner_department_id,
  policies: {
    detect_policy: {
      detect_face: 1,
      multiface_policy: 1,
      estimate_emotions: 1,
      estimate_head_pose: 1,
      estimate_mask: 1,
      yaw_threshold: 30,
      roll_threshold: 30,
      pitch_threshold: 30,
      estimate_liveness: {
        estimate: 1,
        liveness_threshold: 0.5,
      },
    },
    extract_policy: {
      extract_basic_attributes: 1,
      extract_face_descriptor: 0,
      fd_score_threshold: 0.1,
    },
    storage_policy: {
      face_sample_policy: {
        store_sample: 0,
      },
      event_policy: {
        store_event: 1,
      },
    },
  },
});
